import { ScrollRestoration } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("_app", (props) => {
  return (
    <>
      <ScrollRestoration />
      {/* <Header /> */}
      {props.children}
      {/* <Footer /> */}
    </>
  )
})
